import { auth } from "./firebaseConfig";

const SKILL_TEST_API_URL = "https://gemini-tts-api-5r2d6nagzq-uw.a.run.app/run-skill-test";

export async function runPodcastSkillTest({ inputLocation, skillsFolder, outputFolder, statusFirestoreLocation }) {
  const user = auth.currentUser;
  if (!user) throw new Error("You must be signed in to run a podcast test.");

  const token = await user.getIdToken();
  const response = await fetch(SKILL_TEST_API_URL, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      input_location: inputLocation,
      skills_folder: skillsFolder,
      output_folder: outputFolder,
      status_firestore_location: statusFirestoreLocation,
    }),
  });
  const result = await response.json().catch(() => ({}));

  if (!response.ok) {
    const fallback = response.status === 401
      ? "Your session is not authorized. Please sign in again."
      : response.status === 422
        ? "The backend rejected one or more Storage locations."
        : `The test could not be submitted (HTTP ${response.status}).`;
    throw new Error(result.detail || result.error || fallback);
  }

  return result;
}
